import * as React from "react"
import type { SVGProps } from "react"
const SvgStarCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 15.66 2.78 2.1q.3.2.6.02t.17-.54l-1.05-3.48 2.73-1.95q.3-.22.17-.56t-.47-.34H13.6l-1.12-3.65q-.13-.35-.48-.35-.36 0-.47.35l-1.13 3.65H7.08q-.36 0-.48.34t.18.56l2.72 1.95-1.05 3.48q-.12.35.18.54.3.18.6-.02zm0 7.05a10 10 0 0 1-3.9-.78 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.18 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.17Q6.28 4.29 8.1 3.5a10 10 0 0 1 3.9-.79q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.79Zm0-2q3.33 0 5.66-2.33A7.7 7.7 0 0 0 20 12.7q0-3.32-2.34-5.66T12 4.71c-3.33 0-4.1.78-5.66 2.34A7.7 7.7 0 0 0 4 12.71q0 3.32 2.34 5.67A7.7 7.7 0 0 0 12 20.7" />
  </svg>
)
export default SvgStarCircle
